import api from "api";

const affiliate = {
    getLink: () => {
        return api().get('/affiliate/link');
    },

    getSummary: () => {
        return api().get('/affiliate/summary');
    },
}

export default affiliate;
